import React from 'react';
import { Toggle } from 'rsuite';

export const ToggleButton = ({ checked, onChange, outLine, size }) => {
  return <Toggle checked={checked} size={size} onChange={onChange} className={`custom-check ${outLine && 'out-line'}`} />;
};
